module.exports = new __parcel__URL__("report-default.ef0cd7c2.svg").toString();